<script>
export default {
  install(Vue) {
    Vue.prototype.$track = function (action, targetName, targetRef) {
      // We really shouldn't call this function with these parameters at all, but we have code that resolve Solr entities to a target name so this seems like the easier solution.
      if (action == "impression" && targetName == "article") {
        return false;
      }
      var el = this.$el;
      if (el && window.trackerEnabled) {
        var isRendered = function (element) {
          var rect = element && element.getBoundingClientRect ? element.getBoundingClientRect() : null;
          return rect && (rect.x < 0 || rect.x > 0 || rect.y < 0 || rect.y > 0);
        }
        var isVisible = function (element) {
          if (element.parentNode) {
            try {
              if (window.getComputedStyle(element).display == "none") {
                return false;
              }
            } catch {
              return false;
            }
            return isVisible(element.parentNode);
          }
          return true;
        }
        if (isRendered(el) && isVisible(el) && action && targetName && targetRef) {
          window.queueTrackerEvent(action, "host", window.hostId, targetName, targetRef);
          return true;
        }
      }
      return false;
    }
  }
}
</script>
